/* eslint-disable */
import store from "../../store/index";
import axios from "axios";

export default {
    name: "AssignSdvModal",
    props: {
        signalid: {
            type: String,
            default: "",
        },
        
    },
    data() {
        return {
            idToken: "",
            headerValues: "",
            baseapi: process.env.VUE_APP_Service_URL,
            
            loadingBlock: false,
            // roles + recipients
            roleList: [],
            selectedRole: "",     
            recipients: [],      
            values: {
                Recipient: ""      
            },

            // errors
            errors: [],
                };
    },
    async mounted() {
        console.log("AssignSdvModal mounted with signalid:", this.signalid);
        this.idToken = store.getters.getIdToken;
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
     
        await this.getRoleList(); 
    },
    methods: {
        async getRoleList() {
            const idtoken = store.getters.getIdToken;
             axios
                .get(
                `${this.baseapi}/account-core/roles/rolelist`,
                {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                }
                ).then((res) => {
                    this.roleList = res.data;
                })
        },
        async getRoleBasedUserlist(roleId) {
      try {
        console.log("sdasdasdssassssssssssss",roleId);
        const studyId = store.getters.getStudyIs;
        const res = await axios.get(
          `${this.baseapi}/account-core/user/getusersbyrole?roleids=${roleId}&studyid=${studyId}`,
          this.headerValues
        );
        this.recipients = res.data;
      } catch (err) {
        console.error("Error fetching users by role", err);
        this.recipients = [];
      }
    },
 
    async roleChanged() {
      console.log("Selected role:", this.selectedRole); 
      if (this.selectedRole) {
        await this.getRoleBasedUserlist(this.selectedRole);
        this.values.Recipient = ""; 
      } else {
        this.recipients = [];
        this.values.Recipient = "";
      }
    },
    
        async assignSdv() {
           
            try {
                await axios.post(
                    `${this.baseapi}/stats-python/formstatistics/createassignsdv`,
                    {
                        DataSignalId:this.signalid,
                        AssignedToEmail: this.values.Recipient,
                    },
                    this.headerValues
                );
                
                alert("SDV Assigned successfully");                
                this.$emit("closeModal");
            } catch (err) {
                console.log("Error Assigning  SDV ", err);
            }
        },
        closemodal() {
            this.$emit("closeModal");
        },
    },
};